import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { getTranslationTags } from '../getTranslationTags';
export const SelectCycleDisclaimer = _ref => {
  var _taxStatus$data;
  let {
    isMobile
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  const taxStatus = module.SDK.eclipseOfferingApiClient.hooks.useFetchTaxStatus({});
  const isPricesIncludeTax = ((_taxStatus$data = taxStatus.data) == null ? void 0 : _taxStatus$data.treatment) === 'INCLUSIVE';
  if (!isPricesIncludeTax) {
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "page_footer.subscription_disclaimer_applicable_tax",
      components: getTranslationTags({
        isMobile
      })
    });
  }
  return null;
};
//# sourceMappingURL=SelectCycleDisclaimer.js.map